export default __webpack_public_path__ + "static/diversity-inclusion-mobile-banner-7b3da5117d8d4956a139f19f7ad7c8c8.png";